module.exports = __webpack_public_path__ + "img/num2.e4799732.png";